import { App } from './App';
import { createApiContextProvider } from 'InternalLibrary/api/ApiContext';
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorManagerProvider } from './ErrorManager';
import { setTheme } from 'InternalLibrary/theme/setTheme';
import { TestingContextProvider } from 'InternalLibrary/testing/TestingContext';
import React, { useEffect } from 'react';

export const createAppProvider: (
  app: App<any, any>,
) => React.FC<React.PropsWithChildren> = (app) => {
  const ApiContextProvider = createApiContextProvider(app);

  return ({ children }) => {
    useEffect(() => {
      setTheme(app.theme);
    }, []);

    return (
      <ErrorManagerProvider app={app}>
        <ErrorBoundary app={app}>
          <TestingContextProvider app={app}>
            <ApiContextProvider>{children}</ApiContextProvider>
          </TestingContextProvider>
        </ErrorBoundary>
      </ErrorManagerProvider>
    );
  };
};
